angular.module('cvsApp').service('updateEmailService', ['networkService', 'xdrService', 'configManager', 'updateEmailServiceModel', 'cvsAppData', '$base64', function(NS, XS, CM, UESM, CAD, $base64) {

    function updateEmail() {
        this.updateEmail = function(callBackSuccess, emailAddress, currentPassword) {
            //get url
            var tokenId = CAD.getTokenId();
            var tokenType = CAD.getTokenType();
            var apikey = CAD.getApiKey();
            var url = CM.getAGPAPIUrl('UPDATE_EMAIL', tokenId, CAD.getTokenType());
            var emailAddress = emailAddress;

            if (url === "URL_ERROR") {

            } else {
                //var url = cvsUtility.updateQueryParam(url, 'appName', 'Portal');
                var request = {
                    url: url,
                    header: {
                        'Content-Type': 'application/xml',
                        'accept': 'application/xml'
                    },
                    data: requestBody(emailAddress, currentPassword),
                    onSuccess: callBackSuccess
                }
                if (cvsUtility.getIEVersion() <= 9) {
                    XS.makeRequest(url, "", xdrSuccess);

                    function xdrSuccess(data) {
                        UESM.setResponse(data);
                        callBackSuccess(UESM.getResponse());
                    }
                } else {
                    // console.log("reqqqqqq", request);
                    var promise = NS.post(request);
                    promise.then(function(data, c, d) {

                        UESM.setResponse(data.data);
                        callBackSuccess(UESM.getResponse());

                    }, function(reason) {
                        callBackSuccess(NS.httpError(reason));
                    });
                }
            }

        }

        var requestBody = function(emailAddress, currentPassword) {
            var tokenId = CAD.getTokenId();
            var tokenType = CAD.getTokenType();
            tokenType = CM.getAGPTokenType(tokenType);
            var apikey = CAD.getApiKey();
            var emailAddress = emailAddress;
            var x2js = new X2JS();
            var xmlReq = x2js.json2xml_str( {
                "updateEmailRequest": {
                    "header": {
                        "serviceContext": {
                            "appName": cvsUtility.queryMap.mobileAppStyle ? 'SPL_APP' : 'SPL_WEB',
                            "lineOfBusiness": "Specialty",
                            "channelName": cvsUtility.queryMap.channel,
                            "tokenID": tokenId,
                            "tokenType": tokenType,
                            "responseFormat": "XML"
                        },
                        "securityContext": {
                            "apiKey": apikey,
                            "securityType": "apikey"
                        }
                    },
                    "details": {
                        "password" : '$$$$$',
                        "emailAddress": $base64.encode(emailAddress)
                     }
                }
            });

            return xmlReq.replace('$$$$$', '<![CDATA['+currentPassword+']]>');

        }

    }

    return new updateEmail();
}]);
